
import { muiDataGridStarted } from "../apiutils";
import { apiSlice } from "../createApiSlice";

const SHIPPERS_BASE = "/shipperprofiles";
const buildUrl = (endpoint) => SHIPPERS_BASE + endpoint;
const ApiName = "ShipperProfiles";


const shippersApiSlice =  apiSlice.injectEndpoints({
    endpoints: builder => ({
        getShipperProfiles: builder.query({
            query: ({ args, invalidate }) => ({
                url: buildUrl(`?page=${args.page}&size=${args.size}`),
                method: 'POST',
                body: args.body,
            }),
            providesTags: (result, error, arg) => [{ type: `${ApiName}` , identifier: 'datatable'}],
            onQueryStarted: muiDataGridStarted.bind(null, 'getShipperProfiles', `${ApiName}`)
        }),
        getReturnProfiles: builder.query({
            query: ({ args, invalidate }) => ({
                url: buildUrl(`?page=${args.page}&size=${args.size}&allowReturn=true`),
                method: 'POST',
                body: args.body,
            }),
            providesTags: (result, error, arg) => [{ type: `${ApiName}` , identifier: 'datatable-returns'}],
            onQueryStarted: muiDataGridStarted.bind(null, 'getReturnProfiles', `${ApiName}`)
        }),
        getAllShipperProfilesSelect: builder.query({
            query: (args) => ({
                url: buildUrl(`/select`),
                method: 'GET'
            }),
            providesTags: (result, error, arg) => [{ type: `${ApiName}`, id: arg }]
        }),
        getAllReturnShipperProfilesSelect: builder.query({
            query: queryOptions => ({
                url: buildUrl(`/select/return${queryOptions?.shipper ? `?shipper=${queryOptions.shipper}` : ''}`),
                method: 'GET'
            }),
            providesTags: (result, error, arg) => [{ type: `${ApiName}Return`, id: arg }]
        }),
        getRelationLabelShipperProfilesSelect: builder.query({
            query: () => ({
                url: buildUrl(`/select/relation-label`),
                method: 'GET'
            }),
            providesTags: (result, error, arg) => [{ type: `${ApiName}RelationLabel` }]
        }),
        getShipperProfile: builder.query({
            query: id => ({
                url: buildUrl(`/${id}`),
                method: 'GET'
            }),
            providesTags: (result, error, arg) => [{ type: `${ApiName}Single`, id: arg }]
        }),
        addNewShipperProfile: builder.mutation({
            query: shipperInfo => {
                
                return {
                    url: buildUrl(`/new`),
                    method: 'POST',
                    body: shipperInfo,
                }
            },
            invalidatesTags: [`${ApiName}`],
        }),
        editShipperProfile: builder.mutation({
            query: shipperInfo => ({
                url: buildUrl(`/${shipperInfo.id}`),
                method: 'PUT',
                body: shipperInfo,
            }),
            invalidatesTags: (result, error, arg) => [{ type: `${ApiName}Single`, id: arg.id }, {type: `${ApiName}`},{type: `${ApiName}Return`}],
        }),
        deleteShipperProfile: builder.mutation({
            query: id => ({
                url: buildUrl(`/${id}`),
                method: 'DELETE'
            }),
            invalidatesTags: (result, error, arg) => [{ type: `${ApiName}Single`, id: arg.id }, {type: `${ApiName}`},{type: `${ApiName}Return`}],
        }),
        validateShipperProfile: builder.mutation({
            query: ({ shipperType, profileData, shipperId = null }) => ({
                url: buildUrl('/validate'),
                method: 'POST',
                body: { 
                    shipperType, 
                    profileData,
                    shipperId
                }
            }),
        }),
    })
});

export const {
    useGetShipperProfilesQuery,
    useGetReturnProfilesQuery,
    useGetAllShipperProfilesSelectQuery,
    useGetShipperProfileQuery,
    useAddNewShipperProfileMutation,
    useEditShipperProfileMutation,
    useDeleteShipperProfileMutation,
    useValidateShipperProfileMutation,
    useGetAllReturnShipperProfilesSelectQuery,
    useGetRelationLabelShipperProfilesSelectQuery,
  } = shippersApiSlice;